import React from "react";
import GovernanceLinkNav from "../components/GovernanceLinkNav";
import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import PdfPointer from "../components/PdfPointer";
import Footer from "../components/Footer";

const AssociationByLawsAndPolicies = () => {
  const pdfs = [
    {
      pointer: "اللائحة الاساسية للجمعية",
      pdfLink:
        "https://www.saihatss.sa/rafed/uploads/website_regulations/656eac3a4a329.pdf",
    },
    {
      pointer: "سياسة جمع التبرعات",
      pdfLink:
        "https://www.saihatss.sa/rafed/uploads/website_regulations/633b189603487.pdf",
    },
    {
      pointer: "سياسة تنظيم العلاقة مع المستفيدين",
      pdfLink:
        "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc79b0db75.pdf",
    },
    {
      pointer: "اللائحة التنظيمي للعمل التطوعي",
      pdfLink:
        "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc79b0db75.pdf",
    },
    {
      pointer: "سياسة تضارب المصالح",
      pdfLink:
        "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc821f0ba6.pdf",
    },
    {
      pointer: "سياسة الابلاغ عن المخالفات وحماية مقدمي البلاغات",
      pdfLink:
        "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc8406db84.pdf",
    },
    {
      pointer: "سياسة وخصوصية البيانات",
      pdfLink:
        "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc853364a4.pdf",
    },
    {
      pointer: "سياسة الاحتفاظ بالوثائق واتلافها",
      pdfLink:
        "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc862b8178.pdf",
    },
    {
      pointer: "الميثاق الأخلاقي للعاملين في القطاع غير الربحي",
      pdfLink:
        "https://www.saihatss.sa/rafed/uploads/website_regulations/633bc8b71a083.pdf",
    },
  ];
  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <section className="pb-4">
        <div className="max-w-screen-xl mx-auto px-3">
          <h1 className="text-primary font-bold text-center mt-4">
            اللوائح و السياسات
          </h1>
          <GovernanceLinkNav
            title={"الرئيسية"}
            module={"اللوائح و السياسات"}
          ></GovernanceLinkNav>
          <div className="mt-8">
            {pdfs.map((pdf) => (
              <PdfPointer
                pointer={pdf.pointer}
                pdfLink={pdf.pdfLink}
              ></PdfPointer>
            ))}
          </div>
        </div>
      </section>
      <Footer></Footer>
    </>
  );
};

export default AssociationByLawsAndPolicies;
